"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CREATE_CUSTOMER_ID = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var CREATE_CUSTOMER_ID = '-1';
exports.CREATE_CUSTOMER_ID = CREATE_CUSTOMER_ID;
var defaults = {
  id: null,
  name: '',
  companyName: '',
  emailAddress: '',
  billingAddress: (0, _immutable.Map)({
    lineOne: '',
    state: '',
    countrySubDivisionCode: '',
    postalCode: '',
    city: ''
  })
};

var AccountingCustomer =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(AccountingCustomer, _Record);

  function AccountingCustomer() {
    (0, _classCallCheck2.default)(this, AccountingCustomer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AccountingCustomer).apply(this, arguments));
  }

  return AccountingCustomer;
}((0, _immutable.Record)(defaults));

var _default = AccountingCustomer;
exports.default = _default;